import VueRouter from 'vue-router';
import http from '@/utils/http';


// 公司简介
import briefIntr from "@/page/briefIntr/briefIntr.vue";
// 登录
import login from "@/page/login/login.vue";
// 注册选择身份
import rega from "@/page/regZc/rega.vue";
// 注册老师
import regb from "@/page/regZc/regb.vue";
// 注册学生
import regc from "@/page/regZc/regc.vue";
// 首页
import home from "@/page/home/home.vue";
// [back] 
// 首页搜索结果
import searPage from "@/page/home/searPage.vue";
// [back] 
// 个人信息
import myInfo from "@/page/user/myInfo.vue";
// [back] 
// 帮助中心
import feedback from "@/page/qTa/feedback.vue";
// [back]
// 共享互助 
// 资源库最新试卷 资源库同步课件 资源库优质课件 资源库双语新闻 
// 资源库扩展阅读 资源库双语节目 资源库英文小说 资源库荐阅外刊 
// 资源库优质课 资源库每日一听
import gongxiangHz from "@/page/tab/gongxiangHz.vue";
// [back]
// 常用工具
import changyGj from "@/page/tab/changyGj.vue";
// [back]
// 需求申请
import xuqiuSq from "@/page/tab/xuqiuSq.vue";
// [back]
// 我要组卷
import zujuan from "@/page/tiku/zujuan.vue";
// [back]
// 我要组卷>选择模板
import xuanzMb from "@/page/tiku/xuanzMb.vue";
// [back]
// 我要组卷>选择试题
import tihuanKt from "@/page/tiku/tihuanKt.vue";
// [back]
// 我的试卷
import mySj from "@/page/myShijuan/mySj.vue";
// [back]
// 资源库美文 资源库演讲 资源库歌曲
import zlmwHome from "@/page/tab/zlmwHome.vue";
// [back]
// 资源库电影
import dianyingHome from "@/page/tab/dianyingHome.vue";
// [back]
// 资源库每期课件
import kejianTj from "@/page/tab/kejianTj.vue";
// [back]
// 资源库高考真题 资源库高频词汇
import zystHome from "@/page/tiku/zystHome.vue";
// [back]
// 资源库听力课本
import tingliHome from "@/page/tiku/tingliHome.vue";
// [back]
// 资源库美文>美文详情
// 资源库演讲>演讲详情
// 资源库歌曲>歌曲详情
// 资源库电影>电影详情
// 资源库双语新闻>新闻详情
import scDec from "@/page/user/scDec.vue";
// [back]
// 资源库最新试卷>试卷详情
// 资源库同步课件>课件详情
// 资源库优质课件>课件详情
// 资源库扩展阅读>阅读详情
// 资源库双语节目>节目详情
// 资源库英语小说>小说详情
// 资源库荐阅外刊>外刊详情
// 资源库优质课>优质课详情
import hbDec from "@/page/user/hbDec.vue";
// [back]
// 资源库每期课件>课件详情
// 首页每期课件>课件详情
import mqDec from "@/page/user/mqDec.vue";
// [back]
// 资源库每日一听>一听详情
// 资源库高考真题>真题详情
import timDec from "@/page/user/timDec.vue";
// [back]
// 资源库听力课本>课本详情
import tingliDec from "@/page/tiku/tingliDec.vue";
// [back]
// 资源库高考真题>详情>模拟考试
import kaoshi from "@/page/user/kaoshi.vue";
// [back]
// 资源库高考真题>详情>模拟考试>结束考试
import kaoshiZj from "@/page/user/kaoshiZj.vue";
// [back]
// 资源库高考真题>详情>模拟考试>结束考试>同类题
import yulanSt from "@/page/user/yulanSt.vue";
// [back]
// 我的班级
import myBanji from "@/page/myShijuan/myBanji.vue";
// [back]
// 班级管理
import banjiHome from "@/page/myShijuan/banjiHome.vue";
// [back]
// 用户协议 隐私政策
import userAgreen from "@/page/qTa/userAgreen.vue";
// [back]
// 机考-套题资源
import taotiziyuan from "@/page/jikao/taotiziyuan.vue";
// 机考-试听
import shiting from "@/page/jikao/shiting.vue";
// 机考-正式考试
import jikao from "@/page/jikao/jikao.vue";


export default new VueRouter({
	routes: [{
			path: '/',
			component: briefIntr,
			meta: {
				isTourist: true,
				name: '首页'
			},
			beforeEnter(to, from, next) {
				if (!localStorage.getItem('icpData')) {
					http.get(`api/system/dict/data/config/app_icp`).then(res => {
						if (res.code == 200) {
							localStorage.setItem('icpData', JSON.stringify(res.data))
							this.$store.commit('setIcpData', res.data)
						}
					})
				}
				if (!localStorage.getItem('gaData')) {
					http.get(`api/system/dict/data/config/app_gongan`).then(res => {
						if (res.code == 200) {
							localStorage.setItem('gaData', JSON.stringify(res.data))
							this.$store.commit('setGaData', res.data)
						}
					})
				}
				if (!localStorage.getItem('wjData')) {
					http.get('api/app/yydBanner/list', {
						params: {
							type: 6
						}
					}).then(res => {
						if (res.code == 200) {
							localStorage.setItem('wjData', JSON.stringify(res.data))
						}
					})
				}
				if (!localStorage.getItem('mtData')) {
					http.get('api/app/yydBanner/list', {
						params: {
							type: 7
						}
					}).then(res => {
						if (res.code == 200) {
							localStorage.setItem('mtData', JSON.stringify(res.data))
						}
					})
				}
				let token = localStorage.getItem('token')
				if (token) {
					next({
						path: 'home'
					})
				} else {
					next()
				}
			}
		},
		{
			path: '/briefIntr',
			component: briefIntr,
			meta: {
				isTourist: true,
				name: '简介'
			},
		},
		{
			path: '/login',
			meta: {
				isTourist: true,
				name: '登录页'
			},
			component: login,
		},
		{
			path: '/home',
			meta: {
				name: '首页'
			},
			component: home,
		},
		{
			path: '/rega',
			meta: {
				isTourist: true
			},
			component: rega,
		},
		{
			path: '/regb',
			meta: {
				isTourist: true
			},
			component: regb,
		},
		{
			path: '/regc',
			meta: {
				isTourist: true
			},
			component: regc,
		},
		{
			path: '/userAgreen',
			meta: {
				name: '协议'
			},
			component: userAgreen,
		},
		{
			path: '/feedback',
			meta: {
				name: '需求申请'
			},
			component: feedback,
		},
		{
			path: '/searPage',
			meta: {
				name: '搜索页'
			},
			component: searPage,
		},
		{
			path: '/myInfo',
			meta: {
				name: '个人中心'
			},
			component: myInfo,
		},
		{
			path: '/scDec',
			meta: {
				name: '资源详情'
			},
			component: scDec,
		},
		{
			path: '/mqDec',
			meta: {
				name: '文档详情'
			},
			component: mqDec,
		},
		{
			path: '/timDec',
			meta: {
				name: '题目详情'
			},
			component: timDec,
		},
		{
			path: '/kaoshi',
			component: kaoshi,
		},
		{
			path: '/kaoshiZj',
			component: kaoshiZj,
		},
		{
			path: '/yulanSt',
			component: yulanSt,
		},
		{
			path: '/hbDec',
			component: hbDec,
		},
		{
			path: '/gongxiangHz',
			component: gongxiangHz,
		},
		{
			path: '/changyGj',
			meta: {
				name: '常用工具'
			},
			component: changyGj,
		},
		{
			path: '/xuqiuSq',
			meta: {
				name: '需求申请'
			},
			component: xuqiuSq,
		},
		{
			path: '/zlmwHome',
			meta: {
				name: '电影列表'
			},
			component: zlmwHome,
		},
		{
			path: '/dianyingHome',
			meta: {
				name: '电影首页'
			},
			component: dianyingHome,
		},
		{
			path: '/kejianTj',
			meta: {
				name: '每日课件'
			},
			component: kejianTj,
		},
		{
			path: '/zystHome',
			meta: {
				name: '听力页'
			},
			component: zystHome,
		},
		{
			path: '/tingliHome',
			meta: {
				name: '听力课本'
			},
			component: tingliHome,
		},
		{
			path: '/tingliDec',
			meta: {
				name: '听力详情'
			},
			component: tingliDec,
		},
		{
			path: '/zujuan',
			meta: {
				name: '组卷'
			},
			component: zujuan,
		},
		{
			path: '/xuanzMb',
			meta: {
				name: '选择模版'
			},
			component: xuanzMb,
		},
		{
			path: '/tihuanKt',
			meta: {
				name: '做题中'
			},
			component: tihuanKt,
		},
		{
			path: '/mySj',
			meta: {
				name: '我的试卷'
			},
			component: mySj,
		},
		{
			path: '/myBanji',
			meta: {
				name: '班级列表'
			},
			component: myBanji,
		},
		{
			path: '/banjiHome',
			meta: {
				name: '我的班级'
			},
			component: banjiHome,
		},
		{
			path: '/taotiziyuan',
			meta: {
				name: '套题资源',
				isTourist: true
			},
			component: taotiziyuan,
		},
		{
			path: '/jikao',
			meta: {
				name: '机考',
				isTourist: true
			},
			component: jikao,
		},
		{
			path: '/shiting',
			meta: {
				name: '试听',
				isTourist: true
			},
			component: shiting,
		},
	]
})